/**
 * More sophisticated validation that allows intermediate decimal states
 * @param input - The input string to validate
 * @returns boolean - Whether the input is valid
 */
export const isValidDecimalInput = (input: string): boolean => {
  // Allow empty string
  if (input === '') return true

  // Allow single minus sign at start
  if (input === '-') return true

  // Allow single decimal point or decimal point at start
  if (input === '.' || input === '-.') return true

  // Allow numbers ending with decimal point (e.g., "2.", "-3.")
  if (/^-?\d+\.$/.test(input)) return true

  // Allow valid decimal numbers (including negative)
  if (/^-?\d*\.?\d*$/.test(input) && input !== '.' && input !== '-') {
    // Make sure it's not just a decimal point or multiple decimal points
    const decimalCount = (input.match(/\./g) || []).length
    return decimalCount <= 1
  }

  return false
}
